import axios from 'axios'
import { getAuthHeader } from '../../utils';

export const v1_modules = async () => {
    const url = `${process.env.REACT_APP_BASE_URL}/v1/modules`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}
